import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MetaService } from '@prekog/pw-common';

@Component({
    selector: 'pw-gyik',
    templateUrl: './gyik.component.html',
    styleUrls: ['./gyik.component.scss']
})
export class GyikComponent {

    constructor(
        private _metaService: MetaService,
        private _router: Router,
    ) {
        this._metaService.settingUpOgUrl();
    }

}
